const citiesData = [
  {
    name: 'Yangon',
    lat: 16.8053,
    lon: 96.1561,
    country: 'GB',
    img: 'https://raw.githubusercontent.com/djaiss/mapsicon/master/europe/gb/512.png',
  },
  {
    name: 'London',
    lat: 44.34,
    lon: 10.99,
    country: 'GB',
    img: 'https://raw.githubusercontent.com/djaiss/mapsicon/master/europe/gb/512.png',
  },
  {
    name: 'Paris',
    lat: 48.8589,
    lon: 2.32,
    country: 'FR',
    img: 'https://raw.githubusercontent.com/djaiss/mapsicon/master/europe/fr/512.png',
  },
  {
    name: 'Rome',
    lat: 41.8933,
    lon: 12.4829,
    country: 'IT',
    img: 'https://raw.githubusercontent.com/djaiss/mapsicon/master/europe/gr/512.png',
  },
  {
    name: 'Spain',
    lat: 40.4167,
    lon: -3.7036,
    country: 'ES',
    img: 'https://raw.githubusercontent.com/djaiss/mapsicon/master/europe/es/512.png',
  },
  {
    name: 'Berlin',
    lat: 52.517,
    lon: 13.3889,
    country: 'DE',
    img: 'https://raw.githubusercontent.com/djaiss/mapsicon/master/europe/de/512.png',
  },
  {
    name: 'Tokyo',
    lat: 35.6767,
    lon: 139.764,
    country: 'JP',
    img: 'https://raw.githubusercontent.com/djaiss/mapsicon/master/asia/jp/512.png',
  },
  {
    name: 'Beijing',
    lat: 39.9062,
    lon: 116.3913,
    country: 'CN',
    img: 'https://raw.githubusercontent.com/djaiss/mapsicon/master/asia/cn/512.png',
  },
  {
    name: 'Singapore',
    lat: 1.2899,
    lon: 103.8519,
    country: 'SG',
    img: 'https://raw.githubusercontent.com/djaiss/mapsicon/master/asia/sg/512.png',
  },
  {
    name: 'Mumbai',
    lat: 19.0785,
    lon: 72.8782,
    country: 'IN',
    img: 'https://raw.githubusercontent.com/djaiss/mapsicon/master/asia/in/512.png',
  },
  {
    name: 'New York',
    lat: 39.6853,
    lon: -93.9269,
    country: 'US',
    img: 'https://raw.githubusercontent.com/djaiss/mapsicon/master/us/us/512.png',
  },
  {
    name: 'Seoul',
    lat: 37.5665,
    lon: 126.978,
    country: 'US',
    img: 'https://raw.githubusercontent.com/djaiss/mapsicon/master/us/us/512.png',
  },
  {
    name: 'Bangkok',
    lat: 13.75,
    lon: 100.5167,
    country: 'US',
    img: 'https://raw.githubusercontent.com/djaiss/mapsicon/master/us/us/512.png',
  },
  {
    name: 'Rio',
    lat: 38.3,
    lon: 21.7833,
    country: 'US',
    img: 'https://raw.githubusercontent.com/djaiss/mapsicon/master/us/us/512.png',
  },
  {
    name: 'Hong Kong',
    lat: 22.2855,
    lon: 114.1577,
    country: 'US',
    img: 'https://raw.githubusercontent.com/djaiss/mapsicon/master/us/us/512.png',
  },
  {
    name: 'Moscow',
    lat: 55.7522,
    lon: 37.6156,
    country: 'US',
    img: 'https://raw.githubusercontent.com/djaiss/mapsicon/master/us/us/512.png',
  },
  {
    name: 'Stockholm',
    lat: 59.3314,
    lon: 18.0594,
    country: 'US',
    img: 'https://raw.githubusercontent.com/djaiss/mapsicon/master/us/us/512.png',
  },
  {
    name: 'Abu Dhabi',
    lat: 24.4667,
    lon: 54.3667,
    country: 'US',
    img: 'https://raw.githubusercontent.com/djaiss/mapsicon/master/us/us/512.png',
  },
  {
    name: 'Cairo',
    lat: 30.0626,
    lon: 31.2497,
    country: 'US',
    img: 'https://raw.githubusercontent.com/djaiss/mapsicon/master/us/us/512.png',
  },
  {
    name: 'Amsterdam',
    lat: 52.374,
    lon: 4.8897,
    country: 'US',
    img: 'https://raw.githubusercontent.com/djaiss/mapsicon/master/us/us/512.png',
  },
];

export default citiesData;
